<div class="duzlem-hareket-container">

    <!-- Hareket Kontrolleri -->
    <div class="control-group">
        <div class="axis-controls">
            <button class="btn-arrow" (click)="duzlemGeri()" title="Geri">
                <i class="icon arrow left"></i>
            </button>
            <div class="input-wrapper">
                <input
                    type="number"
                    [(ngModel)]="hizliHareketMiktari"
                    min="0.1"
                    step="0.1"
                    value="1"
                    class="minimal-input">
            </div>
            <button class="btn-arrow" (click)="duzlemIleri()" title="İleri">
                <i class="icon arrow right"></i>
            </button>
        </div>
    </div>

    <!-- Dönme Kontrolleri -->
    <div class="control-group">
        <div class="rotation-grid">
            <div class="rot-control">
                <span class="axis-label x">X</span>
                <div class="rot-buttons">
                    <button class="btn-rot" (click)="duzlemDondurX(-1)">↺</button>
                    <button class="btn-rot" (click)="duzlemDondurX(1)">↻</button>
                </div>
            </div>
            <div class="rot-control">
                <span class="axis-label y">Y</span>
                <div class="rot-buttons">
                    <button class="btn-rot" (click)="duzlemDondurY(-1)">↺</button>
                    <button class="btn-rot" (click)="duzlemDondurY(1)">↻</button>
                </div>
            </div>
            <div class="rot-control">
                <span class="axis-label z">Z</span>
                <div class="rot-buttons">
                    <button class="btn-rot" (click)="duzlemDondurZ(-1)">↺</button>
                    <button class="btn-rot" (click)="duzlemDondurZ(1)">↻</button>
                </div>
            </div>
        </div>
        <div class="angle-input">
            <input
                type="number"
                [(ngModel)]="dondurmeAcisi"
                min="1"
                max="90"
                step="1"
                value="15"
                class="minimal-input">
            <span class="angle-unit">°</span>
        </div>
    </div>

    <!-- Hızlı Eksenler -->
    <div class="control-group">
        <div class="quick-axes">
            <button class="btn-axis" (click)="duzlemEkseneAyarla('x')">X</button>
            <button class="btn-axis" (click)="duzlemEkseneAyarla('y')">Y</button>
            <button class="btn-axis" (click)="duzlemEkseneAyarla('z')">Z</button>
            <button class="btn-axis negative" (click)="duzlemEkseneAyarla('-x')">−X</button>
            <button class="btn-axis negative" (click)="duzlemEkseneAyarla('-y')">−Y</button>
            <button class="btn-axis negative" (click)="duzlemEkseneAyarla('-z')">−Z</button>
        </div>
    </div>

</div>
